import type { CtaFrequency } from 'ProdantixSdk/core/ctas';

const DAY_MS = 86_400_000;

const shownKey = (ctaId: string): string => `prodantix-cta:${ctaId}`;

/** When this visitor was last shown the CTA on this device, if ever. */
export const lastShown = (ctaId: string): number | null => {
  try {
    const stored = window.localStorage.getItem(shownKey(ctaId));
    return stored === null ? null : Number(stored);
  } catch {
    return null;
  }
};

/** Whether this browser session has shown the CTA. */
export const shownThisSession = (ctaId: string): boolean => {
  try {
    return window.sessionStorage.getItem(shownKey(ctaId)) !== null;
  } catch {
    return false;
  }
};

export const rememberShown = (ctaId: string, at: number): void => {
  try {
    window.localStorage.setItem(shownKey(ctaId), String(at));
    window.sessionStorage.setItem(shownKey(ctaId), String(at));
  } catch {
    return;
  }
};

/** Whether the CTA may show again: never shown, a new session for a
 *  once-per-session CTA, or its days passed since it was last shown. */
export const isDue = (frequency: CtaFrequency, last: number | null, isShownThisSession: boolean, now: number): boolean => {
  if (last === null) {
    return true;
  }
  if (frequency.kind === 'once') {
    return false;
  }
  if (frequency.kind === 'session') {
    return !isShownThisSession;
  }
  return now - last >= frequency.value * DAY_MS;
};
